<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">For anyone who ever just got back up and went at it again.</p>
<p class="subsq dedication-content">For MJP. Always.</p>
<p class="subsq dedication-content">For the service men and women who choose to risk their lives, intent on making our world a better place. Heroes all.</p>
<p class="subsq dedication-content">…and for a once in a lifetime dog…</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?ea633ebe